import React, { CSSProperties } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import s from './index.module.less'

interface IProps {
  height?: number
  style?: CSSProperties
}

const Loading: React.FC<IProps> = ({ height, style }) => {
  return (
    <div className={s.loading} style={{ ...style, height }}>
      <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} />} />
    </div>
  )
}

Loading.defaultProps = {
  height: 200,
  style: undefined
}

export default Loading
